import * as React from 'react';
import resultNotFoundImg from '../../../assets/result/result-404.png';

const ResultNotFound = () => <img src={resultNotFoundImg} alt="" />;

export default ResultNotFound;
